"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokenHelper_1 = require("./tokenHelper");
class CotterIdentity {
    constructor(identityToken) {
        this.identifier_id = identityToken.identifier_id;
        this.expire_at = identityToken.expire_at;
        this.identifier = identityToken.identifier;
        this.identifier_type = identityToken.identifier_type;
        this.receiver = identityToken.receiver;
        this.timestamp = identityToken.timestamp;
        this.signature = identityToken.signature;
    }
    validate() {
        var message = `${this.identifier}${this.identifier_type}${this.receiver}${this.expire_at}`;
        var signature = this.signature;
        return tokenHelper_1.ValidateToken(message, signature);
    }
}
exports.default = CotterIdentity;
